import React, { useEffect, useState } from 'react'
import Header from '../header/Header';
import Footer from '../footer/Footer';
import { MdOutlineVideoLibrary } from "react-icons/md";
import img1 from '../../Assests_Url/image-teach.png'
import img2 from '../../Assests_Url/image-video.png'
import video1 from '../../Assests_Url/Keyword_Enhancement.mp4'
import video2 from '../../Assests_Url/CONCEPT_AND_EXPLANATION_VIDEO.mp4'
import video3 from '../../Assests_Url/3D_Modal.mp4'
// import video4 from '../../Assests_Url/'
import video5 from '../../Assests_Url/VIRTUAL_LAB.mp4'
import video6 from '../../Assests_Url/Interactive Exercises.mp4'
import video7 from '../../Assests_Url/Self_Assessments.mp4'
// import video8 from '../../Assests_Url/'
import video9 from '../../Assests_Url/AUDIO_ON_TOUCH.mp4'
import video10 from '../../Assests_Url/Personalisation.mp4'
import video11 from '../../Assests_Url/Dictionary_Translator.mp4'
import video12 from '../../Assests_Url/Multiple_ai.mp4'
import video13 from '../../Assests_Url/COVERAGE_REPORT.mp4'
import video14 from '../../Assests_Url/Multi_Search.mp4'
// import video15 from '../../Assests_Url/'
import { IoArrowUndoCircle, IoColorWandOutline } from "react-icons/io5";
import { PiVideoFill } from "react-icons/pi";
import { MdOutline3DRotation } from "react-icons/md";
import mic from '../../Assests_Url/2d.png'
import vl from '../../Assests_Url/virtual_labs.png'
import iex from '../../Assests_Url/Inter_exer.png'
import { MdAssignment } from "react-icons/md";
import { BiSolidBook } from "react-icons/bi";
import { RiVolumeUpFill } from "react-icons/ri";
import pers from '../../Assests_Url/gridicons.png'
import { FaLanguage } from "react-icons/fa6";
import aisearch from '../../Assests_Url/ai.png'
import coverage from '../../Assests_Url/cov-report.png'
import mul_search from '../../Assests_Url/multi-search.png'
import { VscBook } from "react-icons/vsc";
import { useNavigate } from 'react-router-dom';

const ULearnStandard = ({ RoutesClick, NcertClick }) => {
  const [registerModal, setRegisterModal] = useState(false);
  const [activeTabHeader, setActiveTabHeader] = React.useState("KATBOOK");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);

  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate()


  return (
    <div>
      <div>
        <Header
          activeTab={activeTabHeader}
          handleTabClick={handleTabClickHeader}
          studentregisterModal={studentregisterModal}
          setStudentRegisterModal={setStudentRegisterModal}
          ParentregisterModal={ParentregisterModal}
          setParentRegisterModal={setParentRegisterModal}
          TeacherregisterModal={TeacherregisterModal}
          setTeacherregisterModal={setTeacherregisterModal}
          registerModal={registerModal}
          setRegisterModal={setRegisterModal}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
        />
      </div>

      <div className='container-uteach'>
        <div className='pt-5'>          
          <div className='d-flex align-items-center justify-content-between text-center pb-4'>
            <div>
              <IoArrowUndoCircle size={30} className='back-arrow'
                onClick={() => {
                  navigate("/katbook", { state: { scroll: "bottom" } });
                }}
              />
            </div>
            <div className='found-font'>
              ULearn Higher Standard Books
            </div>
            <div></div>
          </div>

          <div className='text-foun-font text-center py-3'>
            KATBOOK enhances the learning experience for secondary and senior
            secondary levels by combining NCERT/CBSE-aligned content with
            advanced digital learning aids.
          </div>

          <div className='d-flex flex-column align-items-center gap-3 pt-3'>
            <div className='meta-font'>
              The Power of Meta Content
            </div>
            <div className='text-foun-font text-center'>
              NCERT KATBOOKS for higher classes are powered with state-of-the-art
              learning resources curated by subject experts and global content
              creators.
            </div>
            <div className='text-foun-font text-center'>
              Students can use these advanced digital resources to understand complex
              concepts in science, mathematics, computer science, and more with
              greater clarity.
            </div>
          </div>

          <div className='pt-5'>
            <div className='d-flex flex-column gap-5'>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    1. Enhanced Keywords <IoColorWandOutline size={"25px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Important terms, formulae, and concepts are highlighted as keywords.
                    Students can click on them to open a side-by-side screen showing
                    definitions, explanations, derivations, and related references.

                    <ul>
                      <li>
                        Acts as a quick reference during study.
                      </li>
                      <li>
                        Ensures consistent and standardised understanding of key terms.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video1} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    2. Concept & Explanation Videos (Embedded) <PiVideoFill size={"25px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Concept & Explanation Videos are embedded within the KATBOOK to
                    explain difficult or abstract concepts. Students can play, pause,
                    and watch these videos directly without leaving the KATBOOK window.

                    <ul>
                      <li>
                        Provides instant support and saves time by removing the need to search for external sources.
                      </li>
                      <li>
                        Helps standardise understanding across all students.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video2} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    3. 3D Models & Activities <MdOutline3DRotation size={"20px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Interactive 3D models of molecules, body systems, geometric structures,
                    and lab apparatus are available within the KATBOOK. Students can
                    rotate, zoom, and explore them.

                    <ul>
                      <li>
                        Improves understanding of abstract diagrams and scientific structures.
                      </li>
                      <li>
                        Makes complex concepts tangible and interactive.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video3} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    4. 2D Animations <img src={mic} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Step-by-step animations illustrate processes such as chemical
                    reactions, biological functions, physical laws, and more.

                    <ul>
                      <li>
                        Simplifies difficult concepts into clear visual sequences.
                      </li>
                      <li>
                        Helps students learn processes systematically.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={""} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    5. Virtual Labs <img src={vl} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Fully simulated laboratory experiments with a step-by-step interactive
                    methodology are available in Physics, Chemistry, and Biology.
                    Students can perform these experiments digitally.

                    <ul>
                      <li>
                        Provides repeatable and cost-effective practice.
                      </li>
                      <li>
                        Ensures practical learning continues even without physical labs.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video5} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    6. Interactive Exercises <img src={iex} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Session-based interactive activities such as classification, drag-and-drop,
                    and application-based problem-solving exercises are included.
                    Students can solve these activities on their own.

                    <ul>
                      <li>
                        Promotes higher-order thinking and application of concepts.
                      </li>
                      <li>
                        Makes learning engaging and participative.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video6} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    7. Assessments in KATBOOK <MdAssignment size={"25px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    KATBOOK includes a wide range of built-in assessments — multiple choice,
                    fill-in-the-blanks, and short or long answer formats.

                    <ul>
                      <li>
                        Students can attempt assessments to test their knowledge instantly.
                      </li>
                      <li>
                        Keeps learning exciting and interactive.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video7} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    8. Study Material with Q&A Bank (with Solutions) <BiSolidBook size={"25px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Comprehensive study material including solved examples, model answers,
                    and a Q&A bank aligned with board exam patterns is available.

                    <ul>
                      <li>
                        Provides exam-focused preparation support.
                      </li>
                      <li>
                        Offers standardized practice material without needing extra resources.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={""} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className='d-flex flex-column align-items-center gap-3 pt-5'>
            <div className='meta-font'>
              INTERACTIVE FEATURES OF KATBOOK
            </div>
            <div className='text-foun-font text-center'>
              Higher Standards KATBOOKS are equipped with interactive features
              that support independent learning, simplify revision, and provide
              advanced digital tools for exam readiness.
            </div>
          </div>

          <div className='pt-5'>
            <div className='d-flex flex-column gap-5'>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    1. Audio Reader Button <RiVolumeUpFill size={"25px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Students can play the entire session or select passages using the
                    Audio Reader Button for instant audio playback.

                    <ul>
                      <li>
                        Improves pronunciation, fluency, and clarity in language subjects.
                      </li>
                      <li>
                        Supports auditory learning and comprehension.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video9} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    2. Personalisation <img src={pers} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Students can highlight important passages, create digital notes, and
                    bookmark chapters within KATBOOK. All personalized inputs remain saved
                    for future reference.

                    <ul>
                      <li>
                        Functions as a digital study diary.
                      </li>
                      <li>
                        Simplifies revision and improves learning organization.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video10} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    3. Inbuilt Dictionary & Translator <FaLanguage size={"25px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Students can highlight any word or passage to view meanings and synonyms.
                    The built-in translator allows entire passages or words to be translated
                    into regional or preferred languages.

                    <ul>
                      <li>
                        Enhances comprehension and vocabulary.
                      </li>
                      <li>
                        Removes the need for external dictionary or translation apps.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video11} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    4. AI Search <img src={aisearch} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    By highlighting text, students can activate AI Search to instantly
                    generate summaries, derivations, explanations, or even Q&A for that
                    section.

                    <ul>
                      <li>
                        Provides quick and reliable supplementary material.
                      </li>
                      <li>
                        Helps in deeper understanding and exam preparation.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video12} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    5. Coverage Report <img src={coverage} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    When connected with KAMPUS during school-wide rollout, students can
                    track their progress — chapters covered, activities completed, and
                    assessments attempted.

                    <ul>
                      <li>
                        Helps monitor personal progress.
                      </li>
                      <li>
                        Helps parents to also see the book coverage report
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video13} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    6. Multiple Search <img src={mul_search} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Students can highlight and select any word or part of the text from
                    KATBOOK and explore multiple sources for information, including:

                    <ul>
                      <li>
                        AI tools like ChatGPT, Perplexity and more
                      </li>
                      <li>
                        Web browsers
                      </li>
                      <li>
                        Encyclopedias such as Wikipedia, Britannica and more
                      </li>
                      <li>
                        Dictionaries like Merriam-Webster or Oxford
                      </li>

                      This feature allows students to go beyond the textbook and
                      explore subjects more deeply.
                    </ul>

                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video14} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    7. “Try it Yourself” in Computer Science Books <VscBook size={"25px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Computer Science KATBOOKS have an inbuilt coding environment where
                    students can write, run, and test programs directly.

                    <ul>
                      <li>
                        Encourages hands-on programming practice.
                      </li>
                      <li>
                        Strengthens computational thinking and problem-solving skills.
                      </li>
                    </ul>

                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={""} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className='d-flex flex-column align-items-start gap-3 pt-5 pb-3'>
            <div className='meta-font'>
              STUDENT BENEFITS
            </div>
            <div className='cont-para'>
              <ul>
                <li>
                  Provides advanced digital resources for clearer understanding.
                </li>
                <li>
                  Encourages interactive, self-directed, and exam-focused study.
                </li>
                <li>
                  Builds critical thinking, application, and problem-solving skills.
                </li>
                <li>
                  Tracks progress and ensures students stay on top of their learning.
                </li>
              </ul>
            </div>
          </div>


        </div>
      </div>

      <div>
        <Footer
          setActiveTab={setActiveTabHeader}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
        />
      </div>
    </div>
  )
}

export default ULearnStandard
